import React from 'react';
import { NavLink } from 'react-router-dom';
import { RiHomeLine, RiShoppingBagLine, RiMenuLine, RiInformationLine, RiMailLine } from 'react-icons/ri';

const BottomNavigation: React.FC = () => {
  // Check if we're in standalone mode (PWA)
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches || (navigator as any).standalone;

  // If not in standalone mode, don't render anything
  if (!isStandalone) {
    return null;
  }

  const navItems = [
    {
      name: 'Home',
      path: '/',
      icon: <RiHomeLine size={24} />
    },
    {
      name: 'Shop',
      path: '/shop',
      icon: <RiShoppingBagLine size={24} />
    },
    {
      name: 'Categories',
      path: '/categories',
      icon: <RiMenuLine size={24} />
    },
    {
      name: 'About',
      path: '/about',
      icon: <RiInformationLine size={24} />
    },
    {
      name: 'Contact',
      path: '/contact',
      icon: <RiMailLine size={24} />
    },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 h-16">
      <div className="flex justify-around h-full">
        {navItems.map((item) => (
          <NavLink
            key={item.name}
            to={item.path}
            className={({ isActive }) => 
              `flex flex-col items-center justify-center px-4 text-center text-xs 
               ${isActive ? 'text-blue-600' : 'text-gray-600'}`
            }
          >
            {item.icon}
            <span className="mt-1">{item.name}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default BottomNavigation; 